import { createFileRoute } from "@tanstack/react-router";
import { getDocsPage } from "src/server/functions/DocsPage";
import DocsPageView from "./-components/DocsPageView";
import { docsPageHead } from "./-components/docsPageHead";

// Every docs page below /docs. The article is a React Server Component (see getDocsPage); it only
// changes with a deploy.
export const Route = createFileRoute("/docs/$")({
  loader: ({ params }) => getDocsPage({ data: params._splat ?? "" }),
  staleTime: Number.POSITIVE_INFINITY,
  head: docsPageHead,
  component: () => <DocsPageView data={Route.useLoaderData()} />,
});
